<template>
  <div
    class="gf-page-bar"
    :style="pageBarStyle"
  >
    <div
      v-if="!headerData.description"
      class="gf-page-bar__head"
    >
      <h1>{{ headerData.text }}</h1>
    </div>
    <div
      v-else
      class="gf-page-bar__head-with-description"
    >
      <h3>{{ headerData.text }}</h3>
      <p>{{ headerData.description }}</p>
    </div>
    <div
      v-if="$slots.actions"
      class="gf-page-bar__actions"
    >
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GfCustomPageBar',
  props: {
    headerData: {
      type: Object,
      default() {
        return {};
      }
    },
    hasBackground: {
      type: Boolean,
      default: false
    },
    hideOverflow: {
      type: Boolean,
      default: true
    },
    hasBorder: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    pageBarStyle() {
      return [
        { '--gf-page-bar-background': this.hasBackground ? 'var(--light)' : 'none' },
        {
          '--gf-page-bar-border':
            this.hasBackground && this.hasBorder ? '1px solid var(--border-color)' : 'none'
        },
        { '--gf-page-bar-overflow': this.hideOverflow ? 'hidden' : 'visible' }
      ];
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-page-bar';

#{$this} {
  --gf-page-bar-background: 'var(--light)';
  --gf-page-bar-border: '1px solid var(--border-color)';
  --gf-page-bar-overflow: 'hidden';

  display: flex;
  justify-content: space-between;
  background-color: var(--gf-page-bar-background);
  border-bottom: var(--gf-page-bar-border);

  #{$this}__head {
    padding: 36px 16px 0 !important;

    @media screen and (max-width: 767px) {
      padding: 20px 0 0 !important;
    }

    h1 {
      max-width: initial;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: var(--gf-page-bar-overflow);
      font-size: 36px !important;

      @media screen and (max-width: 767px) {
        white-space: normal !important;
        font-size: 26px;
      }
    }
  }

  #{$this}__head-with-description {
    padding: 36px 16px 0 !important;
  }

  #{$this}__actions {
    padding: 0 0px 10px 0;
    display: flex;
    align-items: end;
  }
}
</style>
